<script>
/**
 * Descripción: Botones Personalizados para la DataTables
 *
 * @displayName BaseCustomsButtonsGrid
 */

export default {
  name: 'BaseCustomsButtonsGrid',

  props: {
    /**
     * Función a Ejecutar
     * Default undefined
     */
    label: {
      type: String,
      required: true
    },

    /**
     * Función a Ejecutar
     * Default undefined
     */
    icon: {
      type: String,
      required: true
    },

    /**
     * Función a Ejecutar
     * Default undefined
     */
    fnMethod: {
      type: Function,
      required: true
    }
  },

  /**
   * Ejecutar Click de los buttons
   */
  methods: {
    $_Method() {
      this.fnMethod();
    }
  }
};
</script>

<template>
  <v-btn class="ma-1" depressed small @click="$_Method">
    <v-icon color="black" left>{{ icon }}</v-icon>
    {{ label }}
  </v-btn>
</template>
